import React from "react";
import PropTypes from "prop-types";
import { useSkuAddToListContext } from "./SkuAddToListContext";

/**
 * List - 商品清單子組件
 */
const List = ({ children }) => {
	const { products, handleQuantityChange, handleDeleteProduct, handleOpenQuantityEdit, getProductKey } = useSkuAddToListContext();

	// 確保只有一個子元素
	if (React.Children.count(children) !== 1) {
		throw new Error("SkuAddToList.List 只能接受一個子元素");
	}

	const child = React.Children.only(children);

	// 通過 cloneElement 注入必要的 props（getProductKey 供 formatCell 辨識商品，productID+variantID）
	return React.cloneElement(child, {
		products,
		onQuantityChange: handleQuantityChange,
		onOpenQuantityEdit: handleOpenQuantityEdit,
		onDelete: handleDeleteProduct,
		getProductKey,
		rowKey: typeof getProductKey === "function" ? (row) => getProductKey(row) : "productID",
	});
};

List.propTypes = {
	children: PropTypes.node.isRequired,
};

List.displayName = "SkuAddToList.List";

export default List;
